module.exports = __webpack_public_path__ + "static/media/butterfly.4e75a6e3.svg";